export default class navAdmin {
    constructor (element) {
        this.nav = element
        this.flyout = this.nav.querySelector('#navAdminFlyout')
        this.toggle = this.nav.querySelector('#navAdminCollapse')
        this.toggle.addEventListener('click', this.handleClickToggle.bind(this))
        this.navItemsWithChildren = this.nav.querySelectorAll('.nav-admin-link.hasChildren')
        this.OPEN_CLASS = 'open'

        this.nav.addEventListener('click', this.handleClickNavigation.bind(this))

        this.navItemsWithChildren.forEach(navItem => {
            navItem.addEventListener('mouseenter', this.handleMouseEnter.bind(this))
            navItem.addEventListener('mouseleave', this.handleMouseLeave.bind(this))
        })

        this.flyout.addEventListener('mouseleave', () => this.removeOpenClass(this.flyout))

        this.initialize()
    }

    setMenuLocalStorage (state) {
        localStorage.setItem('isMenuOpen', state ? 'true' : 'false')
    }

    getMenuLocalStorage () {
        const value = localStorage.getItem('isMenuOpen')
        if (value === 'true') {
            return true
        }
        if (value === 'false') {
            return false
        }
        return null
    }

    determineOpenStateFromDom () {
        return this.nav.classList.contains(this.OPEN_CLASS)
    }

    expandMenu (state) {
        if (state) {
            this.addOpenClass(this.nav)
        } else {
            this.removeOpenClass(this.nav)
        }
        this.setMenuLocalStorage(state)
    }

    initialize () {
        const value = this.getMenuLocalStorage()
        if (value === null) {
            this.setMenuLocalStorage(this.determineOpenStateFromDom())
        }
        this.expandMenu(this.getMenuLocalStorage())
    }

    handleClickToggle () {
        this.expandMenu(!this.getMenuLocalStorage())
    }

    handleClickNavigation (event) {
        const { target } = event || {}

        if (!target) {
            return
        }

        if (!this.determineOpenStateFromDom() && target.closest('.nav-admin-search')) {
            this.expandMenu(true)
        }

        if (!target.classList.contains('hasChildren') && !target.parentNode.classList.contains('hasChildren')) {
            return
        }

        const navItem = target.classList.contains('hasChildren') ? target : target.parentNode
        const submenu = navItem.parentNode.querySelector('ul.submenu')

        this.collapseAllSubmenus(submenu)
        this.toggleOpenClass(submenu)

        if (this.nav.classList.contains('open')) {
            this.closeFlyout()
        }
    }

    isSubmenuOpen (target) {
        const submenu = target.parentNode.querySelector('.submenu')
        return !submenu || submenu.classList.contains(this.OPEN_CLASS)
    }

    handleMouseEnter (event) {
        if (this.determineOpenStateFromDom() && this.isSubmenuOpen(event.target)) {
            this.removeOpenClass(this.flyout)
            return
        }
        this.openFlyout(event.target)
    }

    handleMouseLeave (event) {
        if (this.isSubmenuOpen(event.target)) {
            return
        }
        if (event.toElement === this.flyout) {
            return
        }
        if (event.toElement.id === 'offcanvasNavbar') {
            return
        }

        this.closeFlyout()
    }

    openFlyout (target) {
        this.resetFlyout()
        this.createFlyoutContent(target)
        this.setFlyoutOffsetTop(target)
        this.addOpenClass(this.flyout)
        this.setFlyoutMaxHeight()
    }

    closeFlyout () {
        this.resetFlyout()
        this.removeOpenClass(this.flyout)
    }

    createFlyoutContent (target) {
        const tlContent = target.closest('.nav-admin-link-tl').outerHTML
        const submenuContent = target.parentNode.querySelector('.submenu').outerHTML
        this.flyout.innerHTML = tlContent + submenuContent
    }

    setFlyoutOffsetTop (target) {
        const posY = target.getBoundingClientRect().top - this.nav.getBoundingClientRect().top
        this.flyout.style.top = posY + 'px'
    }

    setFlyoutMaxHeight () {
        const { bottom: flyoutBottom, height: flyoutHeight } = this.flyout.getBoundingClientRect()

        if (flyoutBottom > window.innerHeight) {
            const offset = flyoutBottom - window.innerHeight
            const newFlyoutHeight = flyoutHeight - offset
            this.flyout.style.maxHeight = `${newFlyoutHeight}px`
        }
    }

    resetFlyout () {
        this.flyout.innerHTML = ''
        this.flyout.style.maxHeight = 'unset'
    }

    addOpenClass (item) {
        item.classList.add(this.OPEN_CLASS)
    }
    removeOpenClass (item) {
        item.classList.remove(this.OPEN_CLASS)
    }

    toggleOpenClass (item) {
        item?.classList.toggle(this.OPEN_CLASS)
    }

    collapseAllSubmenus (excludeItem = null) {
        this.navItemsWithChildren.forEach(navItem => {
            const subMenu = navItem.parentNode.querySelector('ul')
            if (subMenu === excludeItem) {
                return
            }
            this.removeOpenClass(subMenu)
        })
    }

    destroy () {
    }
}
